import styled from 'styled-components';

export const Button = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.buttons.addButton.background};
  border-radius: 2px;
  border: ${({ theme }) => `solid 1px ${theme.buttons.addButton.border}`};
  cursor: pointer;
  display: flex;
  font-size: 11.5px;
  font-weight: 500;
  height: 34px;
  justify-content: center;
  line-height: 34px;
  padding: 0 10px;

  & > svg {
    height: 11px;
    margin-right: 10px;
     & > path {
      fill: ${({ theme }) => theme.buttons.addButton.color};
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.buttons.addButton.backgroundHover};
    border-radius: 3px;
    border: ${({ theme }) => `solid 1px ${theme.buttons.addButton.border}`};
  }
  
  ${({ disabled, theme }) => {
    if (!disabled) return null;
    return `
      pointer-events: none;
      background-color: ${theme.buttons.disabled.background};
      & > svg {
        & > path {
          fill: ${theme.buttons.disabled.color};
        }
      }
      `;
  }
}
`;
Button.displayName = 'Button';

export const Text = styled.div`
  user-select: none;
  color: ${({ disabled, theme }) => `${disabled ? theme.buttons.disabled.color : theme.buttons.custom.color}`};
  font-size: 11.5px;
  font-weight: 500;
  line-height: 34px;
`;
Text.displayName = 'Text';
